import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginAdmin } from '../services/api';
import toast from 'react-hot-toast';

export const useAuth = () => {
  const navigate = useNavigate();

  const isAuthenticated = !!localStorage.getItem('plus_admin_token');

  const login = useCallback(
    async (username: string, password: string) => {
      const { token } = await loginAdmin(username, password);
      localStorage.setItem('plus_admin_token', token);
      navigate('/dashboard');
      toast.success('Logged in successfully');
    },
    [navigate]
  );

  const logout = useCallback(() => {
    localStorage.removeItem('plus_admin_token');
    navigate('/login');
    toast.success('Logged out');
  }, [navigate]);

  return { isAuthenticated, login, logout };
};
